module.exports = __webpack_public_path__ + "img/customer-converts.e6630db9.svg";